<template>
  <v-app>
    <component :is="layout">
      <router-view />
    </component>
  </v-app>
</template>

<script>
const default_layout = "app-layout";

export default {
  computed: {
    layout () {
      return (this.$route.meta.layout || default_layout)
    },
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
}
</script>
